import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
// import '../../assets/css/icons.css';
import '../../assets/css/style.css'
import '../../Style/popup.css'
import '../../Style/acordian.css'
import { SERVER_IP, PORT, jwt, auth_response_flow, ud } from '../../Server'
import axios from 'axios';
import TypeForm from './TypeForm'

class CreateHierarchy extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            typeHierarchy: [],
            openCreateParent: false,
            selectedParent: 0,
            iseditmode: false,
            selectednode: {}

        }
    }

    getDataFromType = () => {
        var data = {
            jwt: jwt,
            s_id: ud.main_id
        }
        let _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/view/types`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.data.error === false) {
                    var r = _this.convert(response.data.result.result)
                    var filteredJson = r.find(x => x.id === _this.props.id)
                 
                    var tempJson = []
                    tempJson.push(filteredJson)
                    _this.setState({ typeHierarchy: tempJson })
                } else {
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            _this.getDataFromType();
                        }
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    onChangeInput = (e) => {
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value })
    }
    convert = (array) => {
        var map = {};
        for (var i = 0; i < array.length; i++) {
            var obj = array[i];
            obj.children = [];

            map[obj.id] = obj;

            var parent_id = obj.parent_id || '-';
            if (!map[parent_id]) {
                map[parent_id] = {
                    children: []
                };
            }
            map[parent_id].children.push(obj);
        }

        return map['-'].children;

    }
    componentDidMount() {
        this.getDataFromType()
    }
    getInitialState = () => {
        return {
            people: this.state.typeHierarchy
        };
    }
    createParentOpen = () => {
        this.setState({ openCreateParent: true, selectedParent: 0, iseditmode: false })
    }
    selectedNode = (id) => {
        this.setState({ openCreateParent: true, selectedParent: id, iseditmode: false })
    }
    updateTypeForm = () => {
        this.setState({ openCreateParent: false })
        this.getDataFromType()
    }
    editNode = (node) => {
        this.setState({ openCreateParent: true, selectednode: node, iseditmode: true })
    }
    render() {
        var people = this.state.typeHierarchy;
        var nodes = people.map((i) => <TreeNode node={i} children={i.children} selectNode={this.selectedNode} editNode={this.editNode} />)

        return (
            <div>
                {/* <button className="btn btn-primary btn-lg active" onClick={this.createParentOpen}>Create Parent</button> */}
                {this.state.openCreateParent ?
                    <div id="popup" class="overlay">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="exampleStandardModalLabel">Types</h5>
                                    <button type="button" class="close" onClick={() => this.setState({ openCreateParent: false })}>
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <TypeForm updateTypeForm={this.updateTypeForm} parent={this.state.selectedParent} iseditmode={this.state.iseditmode} selectednode={this.state.selectednode} />
                                </div>
                            </div>
                        </div>
                    </div>
                    : null}
                <ul class="parent-accordian">{nodes}</ul>
            </div>
        )
    }
}









//Tree Structure

class TreeNode extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isVisible: false
        }

        // this.handleClick = this.handleClick.bind(this);
    }
    getInitialState = () => {
        return { isVisible: false };
    }

    toggle = (e) => {
        this.setState({ isVisible: !this.state.isVisible });
    }
    getChild = (prop) => {
       
        prop.selectNode(prop.node.id)
    }
    editChild = (prop) => {
       
        prop.editNode(prop.node)
    }

    render() {
        var icon = this.state.isVisible ? 'fa fa-angle-up' : 'fa fa-angle-down';
        var span;
        var nodes;


        if (this.props.children) {
            span = <span className="icon" onClick={this.toggle}><i className={icon}></i></span>;

            if (this.state.isVisible) {
                nodes = this.props.children.map((i) => <TreeNode node={i} children={i.children} selectNode={this.props.selectNode} editNode={this.props.editNode} />);
            }
        }


        return (
            < li className="accordion-item pc-card mb-2">
                <div className="accordion-title-parent">

                    {span}
                    <div className="bag-icon">
                        <i class="fa fa-sitemap mr-2"></i>
                        {this.props.node.name}
                    </div>

                    <div class="act-btn">
                        <button className="btn btn-sm btn-info mr-2" title="Add" onClick={() => this.getChild(this.props)}>
                            <i className="mdi mdi-library-plus"></i>
                        </button>
                        <button className="btn btn-sm btn-secondary" title="Edit" onClick={() => this.editChild(this.props)}>
                            <i className="mdi mdi-pencil"></i>
                        </button>
                    </div>
                </div>
                <ul className="accordion-content">{nodes}</ul>

            </li >

        );
    }
}

export default CreateHierarchy
